export default () => ({
  articleId: null,
  thread: null,
})
